export const SET_ACTIVITY = 'SET_ACTIVITY'
export const RESET_ACTIVITY = 'RESET_ACTIVITY'
